import config from '../env.js';

class ApiService {
    environment = process.env.VUE_APP_ENV?.trim();
    baseUrl() {
        switch(this.environment) {
            case "uat":
                return config.apiURL_uat
            case 'prod':
                return config.apiURL_prod
            default:
                return config.apiURL_local
        }
    }
}

export default ApiService;